export const eventRoundsCopy = {
  gasto: (campanha: string, gasto: string, hora: string, limite: string) =>
    `${campanha} gastou ${gasto} na hora das ${hora}:00, acima do limite de ${limite} por hora.`,
  esgotado: (produto: string, anuncios: number) => {
    const quem = anuncios === 1 ? "um anúncio no ar ainda vende" : `${anuncios} anúncios no ar ainda vendem`;
    return `${produto} acabou no estoque, e ${quem} esse produto.`;
  },
  proximo: "A Nabla olha isto numa rodada curta, sem esperar a próxima: ela propõe o que fazer, e a regra de cada conta decide.",
} as const;
